import React, { useState } from 'react';

const CustomSelect = ({ options, value, onChange, name, id }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative inline-block text-left">
      <div className='grid gap-y-2'>
        <p className='text-right'>الغرض من التواصل</p>
        <input type="text" name={name} id={id} value={value} onChange={(e) => {}} className='hidden'/>
        <button
          type="button"
          className="py-2 px-4 inline-flex justify-between w-full rounded-full border border-gray-300 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          onClick={() => setIsOpen(!isOpen)}
        >
          {value}
          <span className="-ml-1" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#000" d="M18.53 9.53a.75.75 0 0 0 0-1.06H5.47a.75.75 0 0 0 0 1.06l6 6a.75.75 0 0 0 1.06 0z"/></svg>
          </span>
        </button>
      </div>

      {isOpen && (
        <ul className="absolute z-10 mt-2 w-full rounded-md bg-white shadow-lg text-right">
          {options.map((option) => (
            <li
              key={option}
              className="cursor-pointer px-4 py-2 text-gray-700 hover:bg-gray-100"
              onClick={() => {
                onChange(option);
                setIsOpen(false);
              }}
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomSelect;